// removed by extract-text-webpack-plugin
module.exports = {"nav":"NavigationHeading--nav--1X0zE","banner":"NavigationHeading--banner--P_6nM","bannerInner":"NavigationHeading--bannerInner--2ORrv","svgFill":"NavigationHeading--svgFill--MBxaW","svgStroke":"NavigationHeading--svgStroke--1TTeO"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/NavigationHeading/NavigationHeading.css
// module id = 1025
// module chunks = 0